import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from 'utils/notification';
import { ACTIVE_TF, USER_TP } from 'constant';

const List = React.lazy(() => import('./List'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'UserPaymentHistory_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const UserPaymentHistory = () => {
  const { t }: any = useDictionary({ programId: 'user-payment-history' });
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    onSubmit();
  }, []);

  /**
   * on submit
   *
   */
  const onSubmit = async () => {
    const res = await refetchData({
      url: '/user-payment-history/get-payments',
      method: 'GET',
    });
    if (res?.data?.status === '200') {
      setData(res?.data?.data || []);
    } else {
      notification({ res });
    }
  };

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    onSubmit,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <WrapContent>
      <ModuleContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loading} />
          {renderContent()}
        </React.Suspense>
      </ModuleContext.Provider>
    </WrapContent>
  );
};

export default UserPaymentHistory;
